<template>
	<div>
		<vAlert>
            <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
		</vAlert>
		<compWrapper :title="$t('fbb.account.recharge', { defaultValue: '账户充值' })" theme="primary">
			<compFormEdit ref="accountform" class="margin-top-15" :formdata="getAccount" v-model="formData"></compFormEdit>
			<div style="margin-left:120px">
				<vButton theme="primary" @click="submit">{{$t('fbb.rechage.nowrechage', { defaultValue: '立即充值' })}}</vButton>
				<vButton class="margin-left-10" @click="gorecord">{{$t('global.common.return',{defaultValue:'返回'})}}</vButton>
			</div>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>
import { HttpSaveRecharge, HttpGetAccountAmount } from '@/service/recharge';
import { mapState, mapGetters } from 'vuex';
export default {
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
			loading: false,
			formData: {
				organizationName: '',
			},
			valuetext: 0
		};
	},
	created() {
		// this.getDetail();
	},
	computed: {
		// ...mapGetters('dictionary', ['getSysorgList']),
		...mapGetters('dictionary', ['getNextOrgList']),
		getAccount() {
			const _this = this
			return [
				{
					label: this.$t('fbb.rechage.rechageorgname', { defaultValue: '充值账户组织' }),
					key: 'organizationId',
					tag: 'vSelect',
					span: 12,
					options: this.getNextOrgList,
					on: {
						'on-change': function (val) {
							// console.log(val)
							// let nameArray = val.split('$')
							// let name = nameArray[0]
							_this.getAmount(val)
						}
					},
					props: {
						filterable: true,
					}
				},
				{
					valueText: this.$t('fbb.rechage.accountbalance', { defaultValue: '账户余额' }) + this.valuetext + ' USD',
					labelWidth: 0,
					required: false,
					span: 12,
					show: true,
					query: true,
					formItem: {
						style: "margin-left:10px;color:#19be6b"
					},
				},
				{
					label: this.$t('fbb.rechage.datefunds', { defaultValue: '资金到账日期' }),
					key: 'arrivalDate',
					tag: 'vDatepicker',
					span: 24,
					formItem: {
						style: "width:50%"
					},
					props: {
						format: 'yy-mm-dd',
						confirm: false,
					},
				}, {
					label: this.$t('fbb.rechage.topupamount', { defaultValue: '充值金额' }),
					key: 'amount',
					span: 12,
				},
				{
					tag: "span",
					children: "USD",
					labelWidth: 0,
					required: false,
					span: 12,
					show: true,
					formItem: {
						style: "margin-left:10px"
					},
				},
				{
					label: this.$t('global.common.notes', { defaultValue: '备注' }),
					tag: 'vTextarea',
					key: 'remark',
					required: false,
					span: 24,
					formItem: {
						style: "width:50%"
					},
				},]
		},
	},
	methods: {
		// 请求剩余额度
		getAmount(val) {
			HttpGetAccountAmount({
				organizationId: val
			}).then(res => {
				this.valuetext = res.data.availableAmount
			}, err => {

			})
		},
		gorecord() {
			this.$router.push({
				name: 'rechargeRecord',
			})
		},
		async submit() {
			const valid = await this.$refs['accountform'].validate();
			// console.log(!valid)
			if (!valid) return;
			this.formData.organizationName = this.getNextOrgList.filter(item=> { return item.value == this.formData.organizationId})[0].label;
			this.loading = true
			HttpSaveRecharge(this.formData).then(res => {
				this.$VMessage.success(res.message);
				this.gorecord()
			}, err => {
				this.$VMessage.error(err.message);
			}).finally(result => {
				this.loading = false;
			})
		}
	}
};
</script>
